import { useMutation } from '@apollo/client';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { appLinks } from 'src/routing/appLinks';
import type { CreatePricingSheet, CreatePricingSheetVariables } from 'types/graphql';

import { PRICING_SHEETS_PAGE_QUERY } from './usePricingSheetsPage';

const MUTATE_CREATE_PRICING_SHEET = gql`
  mutation CreatePricingSheet($input: CreatePricingSheetInput!) {
    createPricingSheet(input: $input) {
      id
    }
  }
`;

/** "Add Pricing Sheet": creates an empty draft and opens it in the setup stepper. */
export function useCreatePricingSheet() {
  const navigate = useNavigate();
  const [mutate, { loading, error }] = useMutation<CreatePricingSheet, CreatePricingSheetVariables>(
    MUTATE_CREATE_PRICING_SHEET,
    { refetchQueries: [PRICING_SHEETS_PAGE_QUERY] }
  );

  const create = useCallback(async () => {
    const { data } = await mutate({
      variables: { input: { enabled: false, name: '', pricingFormula: 'FLAT_RATE', draft: true } },
    });
    if (!data) throw new Error('Pricing sheet was not created');
    await navigate(appLinks.pricingSheet({ id: data.createPricingSheet.id }));
  }, [mutate, navigate]);

  return { create, loading, error };
}
